import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  ReferenceInput,
  DateInput,
  ArrayInput,
  SimpleFormIterator,
  required,
  TopToolbar,
  DeleteButton,
} from 'react-admin';
import { Box, Typography } from '@mui/material';

const EditActions = () => (
  <TopToolbar>
    <DeleteButton />
  </TopToolbar>
);

export const InvoiceEdit = () => (
  <Edit actions={<EditActions />}>
    <SimpleForm>
      <Typography variant="h6" gutterBottom>
        Basic Information
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2, mb: 2 }}>
        <TextInput source="invoiceNumber" label="Invoice Number" validate={required()} />
        <TextInput source="title" validate={required()} />
        <ReferenceInput source="customerId" reference="customers">
          <SelectInput optionText="name" validate={required()} />
        </ReferenceInput>
        <SelectInput 
          source="status" 
          label="Status"
          choices={[
            { id: 'draft', name: 'Draft' },
            { id: 'sent', name: 'Sent' },
            { id: 'paid', name: 'Paid' },
            { id: 'overdue', name: 'Overdue' },
            { id: 'cancelled', name: 'Cancelled' },
          ]}
          validate={required()}
        />
        <DateInput 
          source="dueDate" 
          label="Due Date" 
          validate={required()} 
          parse={(value) => value ? new Date(value + 'T00:00:00').toISOString() : null}
          format={(value) => value ? value.split('T')[0] : ''}
        />
      </Box>

      <Typography variant="h6" gutterBottom>
        Line Items
      </Typography>
      <ArrayInput source="lineItems">
        <SimpleFormIterator inline>
          <TextInput source="description" label="Description" validate={required()} />
          <NumberInput source="quantity" label="Quantity" validate={required()} />
          <NumberInput source="unitPrice" label="Unit Price" validate={required()} />
          <NumberInput source="amount" label="Amount" disabled />
        </SimpleFormIterator>
      </ArrayInput>

      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
        Financial Details
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2, mb: 2 }}>
        <NumberInput source="subtotal" label="Subtotal" disabled />
        <NumberInput source="taxRate" label="Tax Rate (%)" />
        <NumberInput source="taxAmount" label="Tax Amount" disabled />
        <NumberInput source="totalAmount" label="Total Amount" disabled />
        <NumberInput source="paidAmount" label="Paid Amount" />
        <NumberInput source="balanceAmount" label="Balance Amount" disabled />
      </Box>

      <Typography variant="h6" gutterBottom>
        Payment History
      </Typography>
      <ArrayInput source="payments">
        <SimpleFormIterator inline>
          <DateInput 
          source="paymentDate" 
          label="Payment Date" 
          parse={(value) => value ? new Date(value + 'T00:00:00').toISOString() : null}
          format={(value) => value ? value.split('T')[0] : ''}
        />
          <NumberInput source="amount" label="Amount" />
          <SelectInput 
            source="method" 
            label="Payment Method"
            choices={[
              { id: 'cash', name: 'Cash' },
              { id: 'check', name: 'Check' },
              { id: 'credit_card', name: 'Credit Card' },
              { id: 'bank_transfer', name: 'Bank Transfer' },
              { id: 'other', name: 'Other' },
            ]}
          />
          <TextInput source="notes" label="Notes" />
        </SimpleFormIterator>
      </ArrayInput>

      <Typography variant="h6" gutterBottom>
        Additional Information
      </Typography>
      <TextInput source="notes" multiline rows={3} fullWidth />
      <TextInput source="terms" multiline rows={2} fullWidth />
    </SimpleForm>
  </Edit>
);